import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import BtnListTypeSetting from 'components/property-settings/btn-list-type-setting/btn-list-type-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type SpringTypesProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    springType: string;
    options?: string[];
    isRequired?: boolean;
};

const SpringTypes: FC<SpringTypesProps> = ({ handleSettings, springType, options, isRequired }: SpringTypesProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('SPRING_TYPES')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <BtnListTypeSetting
                setting={options ? options : CONSTANTS.SPRING_TYPES}
                propertyName="springType"
                settingValue={springType}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default SpringTypes;
